// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyAYTMYcY_VWQghFe-575OXWlXi4Zr7c_PE',
    authDomain: 'platzi-square-jdiaz.firebaseapp.com',
    databaseURL: 'https://platzi-square-jdiaz.firebaseio.com',
    projectId: 'platzi-square-jdiaz',
    storageBucket: 'platzi-square-jdiaz.appspot.com',
    messagingSenderId: '918414863575'
  }  
};


// WEBPACK FOOTER //
// C:/Users/USUARIO/Documents/Platzi/cursos__2017/Angular_4_PROFESIONAL/proyectos/platzisquare2/src/environments/environment.ts